import { notification } from 'antd';

type WhyAntdDoesNotExposeThisType = Parameters<typeof notification.open>[0];

type AllowedProps = Pick<
  WhyAntdDoesNotExposeThisType,
  'message' | 'description' | 'icon' | 'duration' | 'key' | 'placement'
>;

export const showNotification = (props: AllowedProps) =>
  notification.open(props);
